import { render, staticRenderFns } from "./keyword-search-form.vue?vue&type=template&id=3d590c05&scoped=true"
import script from "./keyword-search-form.vue?vue&type=script&setup=true&lang=js"
export * from "./keyword-search-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d590c05",
  null
  
)

export default component.exports